import React, { Fragment, useEffect, useState } from "react";
import { Card, Modal, Spinner } from "react-bootstrap";
import VerificationInput from "react-verification-input";

import SpinnerButton from "../SpinnerButton";
import closeSvg from "../../Assets/Images/close.svg";
import "./styles.css";

const ModalOtp = (props) => {
  const {
    show,
    closeModal,
    onChange,
    onClickSubmitOtp,
    onclickGetAgainCode,
    loading,
    isSoftPos,
  } = props;

  const [timer, setTimer] = useState(60);

  let interval;

  useEffect(() => {
    interval = setInterval(() => {
      setTimer((prev) => {
        if (timer === 0) {
          return;
        }
        if (prev === 1) clearInterval(interval);
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  return (
    <Modal show={show} onHide={closeModal} className="modal-otp">
      <div className="modal">
        <div className="modal_content">
          <Card className="p-3">
            <div onClick={closeModal}>
              <img src={closeSvg} />
            </div>
            <Card.Body>
              <Card.Title className="text-center">
                کد تایید پیامک شده را وارد کنید
              </Card.Title>
              <VerificationInput
                lenght={6}
                autoFocus={true}
                className="input1"
                removeDefaultStyles={true}
                container={{ className: "container_" }}
                characters={{ className: "characters" }}
                character={{
                  className: "character",
                  classNameInactive: "character--inactive",
                  classNameSelected: "character--selected",
                }}
                input={{ onChange: onChange }}
              />
              <div className="col-md-12 d-flex align-items-center justify-content-center">
                <SpinnerButton
                  className="component-form-btn"
                  onClick={onClickSubmitOtp}
                  text="ثبت"
                  loading={loading}
                />
              </div>
            </Card.Body>
            <div className="modal_content_footer">
              {!isSoftPos ? (
                <div className="modal_content_footer_link" onClick={closeModal}>
                  تغییر شماره موبایل
                </div>
              ) : null}

              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <Fragment>
                  {timer ? (
                    <div className="modal_content_footer_link">{timer}</div>
                  ) : (
                    <div
                      className="modal_content_footer_link"
                      onClick={() => {
                        setTimer(60);
                        onclickGetAgainCode();
                      }}
                    >
                      ارسال مجدد کد
                    </div>
                  )}
                </Fragment>
              )}
            </div>
          </Card>
        </div>
      </div>
    </Modal>
  );
};
export default React.memo(ModalOtp);
